import React, {useEffect, useState} from "react";

import {Table} from "../../common/table/Table";
import {
    retrieveTrainingPackage,
    retrieveAllTrainingPackages,
} from "../../../services/TrainingService";

export const TrainingSearch = ({context, setContext, navigateTo, showToaster,setSpinnerText}) => {

    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setSpinnerText("Retrieving Trainings...");
            const [data, error] = await retrieveAllTrainingPackages(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    let mappedTrainingPackageList = data.trainingPackageVOList.map((trainingPackageVO) => {
                        let grantName = null;
                        if (trainingPackageVO.grant) {
                            grantName = trainingPackageVO.grant.name;
                        }
                        const moduleName = trainingPackageVO.module.map((trainingModuleVO) => {
                            return trainingModuleVO.trainingModule;
                        });
                        return {...trainingPackageVO, moduleName, grantName}
                    });
                    setSearchResults(mappedTrainingPackageList);
                } else {
                    if (data.responseMessage !== "There was an error when trying to view the Training Package(s). No Training Package(s) found in the database") {
                        showToaster(data);
                    }
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = async (training) => {
        let savedTraining = null;
        const [data, error] = await retrieveTrainingPackage(context.username, training.externalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedTraining = data.trainingPackageVOList[0];
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setContext((prevState) => ({
            ...prevState,
            selectedTraining: savedTraining,
            newTrainingSelected: false,
        }));
        navigateTo("trainingCapture");
    }

    return (
        <div className="problem-search-results-container">
            <div className="problem-search-results-table-container">
                {searchResults &&
                <Table tableData={searchResults}
                       hiddenColumns={["externalReference", "grant", "module", "trainingGroupVOS", "trainingFiles", "numberOfPeopleTrained", "isDeleted", "created", "lastModified"]}
                       onRowClick={handleRowClick}
                />}
            </div>
        </div>
    );
}
